import querystring from 'querystring';
import HmacSHA1 from 'crypto-js/hmac-sha1';
import Hex from 'crypto-js/enc-hex';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getSecretKey } from 'support/player/SyncbakHelper';
import config from 'config';

import parseSyncbak from 'models/syncbak';
import { HttpClient, QueryOptions } from './api-types';

const PRIVATE_KEY = getSecretKey();

export const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: options && options.data ? 'post' : 'get',
  };

  if (options) {
    if (options.params) request.params = options.params;
    request.headers = {
      ...request.headers,
      ...options.headers,
    };
    if (options.data) {
      request.data = querystring.stringify(
        options.data as querystring.ParsedUrlQueryInput,
      );
      request.headers = {
        ...request.headers,
        'content-type': 'application/x-www-form-urlencoded',
      };
    }
  }

  return httpClient(request);
};

const getEncryptedToken = (publicKey: string, privateKey: string): string => {
  const epoch = Math.floor(Date.now() / 1000).toString();
  const signature = epoch + publicKey;
  const token = Hex.stringify(HmacSHA1(signature, privateKey));

  return token;
};
const cleanFetchPlayback = ({
  publicKey,
  resource,
  mvpdId,
}: {
  publicKey: string;
  resource?: string | null;
  mvpdId?: string | null;
}) => {
  /* istanbul ignore next */
  if (!PRIVATE_KEY) throw new Error('Missing Private Key');

  const token = getEncryptedToken(publicKey, PRIVATE_KEY);
  const isValidParam = (val: string | null | undefined): boolean => {
    return !(val === null || val === '' || val === undefined);
  };
  const resourcePath = isValidParam(resource) ? resource : 'undefined';
  const mvpdPath = isValidParam(mvpdId) ? mvpdId : 'undefined';
  return {
    mvpdPath,
    resourcePath,
    token,
  };
};
export const fetchPlaybackV3Url = async (
  httpClient: HttpClient,
  {
    baseUrl,
    publicKey,
    resource,
    mvpdId,
    deviceSerialNum,
    station,
  }: {
    baseUrl: string;
    publicKey: string;
    resource?: string | null;
    mvpdId?: string | null;
    deviceSerialNum: string;
    station?: string | null;
  },
) => {
  if (!baseUrl || !deviceSerialNum) throw new Error('Invalid Parameters');
  const { mvpdPath, resourcePath, token } = cleanFetchPlayback({
    publicKey,
    resource,
    mvpdId,
  });
  const queryString = station
    ? new URLSearchParams({ station }).toString()
    : '';

  // Base Url from kitchen sink has a trailing '/'
  const url = `${baseUrl}${publicKey}/${token}/${resourcePath}/${mvpdPath}/16/${deviceSerialNum}/${
    queryString ? `?${queryString}` : ''
  }`;
  const response = await queryApi(httpClient, url, {
    headers: { 'x-api-key': config.api.apiKey },
  });
  const result = parseSyncbak(response.data); // Note errors come back as HTTP 200

  return result;
};
